
<!-- <app-user-info></app-user-info> -->
<!-- <app-login *ngIf="!isLoggedIn"></app-login> اگر می‌خوای همیشه پایین باشه -->

<app-nav></app-nav>
<router-outlet></router-outlet>

